import { render, staticRenderFns } from "./MtlsFailed.vue?vue&type=template&id=312c1b3c&scoped=true"
import script from "./MtlsFailed.vue?vue&type=script&lang=js"
export * from "./MtlsFailed.vue?vue&type=script&lang=js"
import style0 from "./MtlsFailed.vue?vue&type=style&index=0&id=312c1b3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c1b3c",
  null
  
)

/* custom blocks */
import block0 from "./MtlsFailed.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports